"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageCalendar = void 0;
const startOfToday_1 = __importDefault(require("date-fns/startOfToday"));
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
const Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const BookingStatus_1 = require("../../models/BookingStatus");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useFirestore_1 = require("../../utils/useFirestore");
const useQueryString_1 = require("../../utils/useQueryString");
const BookingFilters_1 = require("../booking-filters/BookingFilters");
const MultiEventCalendar_1 = require("../calendar/MultiEventCalendar");
const IconHelpOutline_1 = require("../icons/IconHelpOutline");
const ManagerBookingTable_1 = require("../manager-tables/ManagerBookingTable");
const NewBookingDropdown_1 = require("../new-booking-dropdown/NewBookingDropdown");
const Spinner_1 = require("../spinner/Spinner");
/** Shows all bookings in a calendar or list view. */
const ManagerPageCalendar = (props) => {
    const [bookings, setBookings] = (0, react_1.useState)([]);
    const [filteredBookings, setFilteredBookings] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [viewFilter, setViewFilter] = (0, useQueryString_1.useQueryStringForString)("view", "week", (value) => ["day", "week", "month"].includes(value));
    const [dateFilter, setDateFilter] = (0, useQueryString_1.useQueryStringForDate)("date", (0, startOfToday_1.default)());
    const [resourcesFilter, setResourcesFilter] = (0, useQueryString_1.useQueryStringForStringArray)("resources", config.resources.map((r) => r.id), "comma");
    const [showCancelled, setShowCancelled] = (0, useQueryString_1.useQueryStringForBoolean)("showCancelled", false);
    const [showListView, setShowListView] = (0, useQueryString_1.useQueryStringForBoolean)("showList", false);
    const [fromDate, toDate] = dateUtils.getViewRange(viewFilter, dateFilter);
    /** Load bookings whenever filters change. Filter in query. */
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const unsubscribeQuery = (0, firestore_1.onSnapshot)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("start", ">=", fromDate), (0, firestore_1.where)("start", "<=", toDate), (0, firestore_1.where)("status", "in", showCancelled
            ? BookingStatus_1.BookingStatus.allStatus.map((s) => s.name)
            : BookingStatus_1.BookingStatus.allBusyStatus.map((s) => s.name))), (querySnapshot) => {
            const bookings = bookingFactory.createAllFromFirestore(querySnapshot.docs, config);
            setBookings(bookings);
            setIsLoading(false);
        }, (err) => {
            console.error(err);
        });
        return () => unsubscribeQuery();
    }, [viewFilter, dateFilter, showCancelled]);
    // Filter bookings (on client).
    (0, react_1.useEffect)(() => {
        setFilteredBookings(bookings.filter((booking) => {
            // Filter Resource.
            if (!resourcesFilter.find((resourceId) => resourceId === booking.getResourceId())) {
                return false;
            }
            return true;
        }));
    }, [bookings, resourcesFilter]);
    let content;
    if (showListView) {
        if (isLoading) {
            content = react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
        }
        else if (filteredBookings) {
            content = (react_1.default.createElement(ManagerBookingTable_1.ManagerBookingTable, { bookings: filteredBookings, show: {
                    date: true,
                    startTime: true,
                    endTime: true,
                    resource: true,
                    title: true,
                    contactName: true,
                    contactOrg: true,
                    bookingStatus: true,
                    invoiceStatus: true,
                } }));
        }
        else {
            content = "Fehler beim Laden der Buchung. Bitte Support kontaktieren.";
        }
    }
    else {
        content = (react_1.default.createElement(MultiEventCalendar_1.MultiEventCalendar, { bookings: filteredBookings, isBookingsLoading: isLoading, view: viewFilter, date: dateFilter, onBookingClick: (booking) => {
                navigate(`/manager/${config.tenantId}/bookings/${booking.reference}/`);
            }, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate }));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container_1.default, { fluid: true, className: "manager-page-calendar main-content d-flex flex-column" },
            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-4 mb-3" },
                react_1.default.createElement("h1", { className: "text-nowrap mb-0" },
                    "Kalender",
                    react_1.default.createElement(OverlayTrigger_1.default, { placement: "right", overlay: react_1.default.createElement(Tooltip_1.default, { id: "title-tooltip" }, "Alle Buchungen in Kalender- oder Listenansicht.") },
                        react_1.default.createElement("span", { className: "text-secondary pl-1 no-print d-none d-sm-inline", style: { fontSize: "20px" } },
                            react_1.default.createElement(IconHelpOutline_1.IconHelpOutline, null)))),
                react_1.default.createElement("div", { className: "d-flex" },
                    react_1.default.createElement("div", { className: "ml-2 mr-2 mr-sm-4" },
                        react_1.default.createElement(Form_1.default.Check, { type: "switch", id: "list-view-switch", label: "Listenansicht", checked: showListView, onChange: (e) => setShowListView(e.target.checked) }),
                        react_1.default.createElement(Form_1.default.Check, { type: "switch", id: "show-cancelled", label: "Annullierte anzeigen", checked: showCancelled, onChange: (e) => setShowCancelled(e.target.checked) })),
                    react_1.default.createElement("div", { className: "mt-1" },
                        react_1.default.createElement(NewBookingDropdown_1.NewBookingDropdown, { className: "no-print", onNewBookingSelected: (resource) => {
                                const date = dateUtils.formatDateIso(dateFilter);
                                navigate(`/manager/${config.tenantId}/bookings/new/?resourceId=${resource.id}&date=${date}`);
                            } })))),
            react_1.default.createElement(BookingFilters_1.BookingFilters, { view: viewFilter, onViewChange: setViewFilter, viewButtons: ["day", "week", "month"], date: dateFilter, onDateChange: setDateFilter, resources: resourcesFilter, onResourcesChange: setResourcesFilter, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate }),
            content)));
};
exports.ManagerPageCalendar = ManagerPageCalendar;
